import { ApexOptions } from "apexcharts";
import ReactApexChart from "react-apexcharts";

export interface IConfigSerieRadarMultiples {
    name: string;
    data: Array<Number>;
}
interface IRadarMultipleSeriesChart {
    series: Array<IConfigSerieRadarMultiples>;
    categories: Array<string>;
}

export function RadarMultipleSeriesChart(props: IRadarMultipleSeriesChart) {
    const options: ApexOptions = {
        chart: {
            type: "bar",
            height: 350,
            width: 500,
            stacked: true,
        },
        plotOptions: {
            bar: {
                horizontal: true,
            },
        },
        stroke: {
            width: 1,
            colors: ["#fff"],
        },
        xaxis: {
            categories: props.categories,
            labels: {
                show: true,
                style: {
                    colors: ["#a8a8a8"],
                    fontSize: "12px",
                    fontFamily: "Arial",
                },
            },
        },
        yaxis: {
            labels: {
                show: true,
                style: {
                    colors: ["#a8a8a8"],
                    fontSize: "10px",
                    fontFamily: "Arial",
                },
            },
        },
        fill: {
            opacity: 1,
        },
        legend: {
            position: "top",
            horizontalAlign: "left",
            offsetX: 40,
        },
    };

    return (
        <>
            <div id="chart">
                <ReactApexChart
                    options={options}
                    series={props.series}
                    type="bar"
                    height={350}
                    css={{}}
                />
            </div>
        </>
    );
}
